import { Box, Drawer } from '@mui/material';
import { Button } from '@portals/core/src/components/Button/Button';
import { Divider } from '@portals/core/src/components/Divider/Divider';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { ChevronLeft, ChevronLeftSmall } from '@portals/icons';
import { getFixedT } from 'i18next';
import React, { useCallback } from 'react';

import { Criteria } from '../../../../config';
import { AllFilters } from './AllFilters/AllFilters';
import { styles } from './FilterDrawer.styles';
import { FilterDrawerActions } from './FilterDrawerActions/FilterDrawerActions';

const t = getFixedT(null, 'core-immobilien');

interface AllFilterProps {
  visible: boolean;
  criteria: Criteria | null;
  showAllFilter: boolean;
  changeCriteria: (criteria: Criteria) => void;
  close: () => void;
  resetFilters: () => void;
}

export const FilterDrawer: React.FC<AllFilterProps> = ({
  visible,
  criteria,
  showAllFilter,
  changeCriteria,
  close,
  resetFilters,
}) => {
  const handleCancel = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      resetFilters();

      if (showAllFilter && criteria !== null) {
        changeCriteria(null);
        return;
      }
      close();
    },
    [changeCriteria, close, criteria, resetFilters, showAllFilter]
  );

  return (
    <Drawer
      data-id="estate-result-filter-drawer"
      anchor="right"
      open={visible}
      onClose={close}
      PaperProps={{ sx: styles.drawerPaper }}
    >
      <Box sx={styles.drawerPaperWrapper}>
        <Box sx={styles.drawerHeader}>
          <Button onClick={close} variant="inverted" sx={styles.closeButton}>
            <ChevronLeftSmall sx={styles.closeButtonSvgSM} />
            <ChevronLeft sx={styles.closeButtonSvgLG} />
            {t('back')}
          </Button>
          <Divider />
        </Box>

        <Box sx={styles.drawerContent}>
          <Typography variant="h3" sx={styles.contentTitle}>
            {t('customizeSearch')}
          </Typography>
          <AllFilters sx={styles.contentFilters} />
        </Box>
        <Box sx={styles.drawerFooter}>
          <FilterDrawerActions criteria={criteria} handleCancel={handleCancel} close={close} sx={styles.buttonGrid} />
        </Box>
      </Box>
    </Drawer>
  );
};

FilterDrawer.displayName = 'FilterDrawer';
